(function () {
  const section = document.querySelector('[data-snr-encyclopedia]');
  if (!section) return;

  const grid = section.querySelector('[data-encyclopedia-grid]');
  const searchInput = section.querySelector('[data-encyclopedia-search]');
  const clearButton = section.querySelector('[data-encyclopedia-clear]');
  const emptyState = section.querySelector('[data-encyclopedia-empty]');
  const perPageSelect = section.querySelector('[data-encyclopedia-per-page]');

  let items = [];

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function collectExistingItems() {
    if (!grid) return;

    grid.querySelectorAll('.snr-encyclopedia__item').forEach((node) => {
      items.push({
        node,
        searchText: normalize(node.dataset.searchText || ''),
      });
    });
  }

  function updateUI() {
    if (!searchInput) return;

    const query = normalize(searchInput.value.trim());
    let visibleCount = 0;

    items.forEach(({ node, searchText }) => {
      const visible = !query || searchText.includes(query);
      node.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount += 1;
    });

    if (emptyState) {
      emptyState.classList.toggle('is-visible', query.length > 0 && visibleCount === 0);
    }

    if (clearButton) {
      clearButton.classList.toggle('is-visible', query.length > 0);
    }
  }

  function bindEvents() {
    searchInput?.addEventListener('input', updateUI);

    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.focus();
      updateUI();
    });

    perPageSelect?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('per_page', perPageSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  collectExistingItems();
  bindEvents();
  updateUI();
})();
